var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar",class:{inline: _vm.inline}},[(!_vm.inline)?_c('input',{ref:"input",attrs:{"type":"text"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }